import chatgptLogo from '@/assets/llm-logos/chatgpt.png';
import claudeLogo from '@/assets/llm-logos/claude.png';
import geminiLogo from '@/assets/llm-logos/gemini.png';
import grokLogo from '@/assets/llm-logos/grok.png';
import perplexityLogo from '@/assets/llm-logos/perplexity.png';
import deepseekLogo from '@/assets/llm-logos/deepseek.png';

export enum LlmProvider {
  ChatGPT = 'chatgpt',
  Claude = 'claude',
  Gemini = 'gemini',
  Perplexity = 'perplexity',
  Grok = 'grok',
  DeepSeek = 'deepseek',
}

export const LLM_PROVIDER_LABELS: Record<LlmProvider, string> = {
  [LlmProvider.ChatGPT]: 'ChatGPT',
  [LlmProvider.Claude]: 'Claude',
  [LlmProvider.Gemini]: 'Gemini',
  [LlmProvider.Perplexity]: 'Perplexity',
  [LlmProvider.Grok]: 'Grok',
  [LlmProvider.DeepSeek]: 'DeepSeek',
};

export const LLM_PROVIDER_LOGOS: Record<LlmProvider, string> = {
  [LlmProvider.ChatGPT]: chatgptLogo,
  [LlmProvider.Claude]: claudeLogo,
  [LlmProvider.Gemini]: geminiLogo,
  [LlmProvider.Grok]: grokLogo,
  [LlmProvider.Perplexity]: perplexityLogo,
  [LlmProvider.DeepSeek]: deepseekLogo,
};

export const ALL_LLM_PROVIDERS = Object.values(LlmProvider);
